import { Validator } from 'vee-validate';
import { ValidateUser } from '@/services/generated/edge/user';
import * as _ from 'lodash';
//import { PhoneNumberUtil } from 'google-libphonenumber';

//const phoneUtil = PhoneNumberUtil.getInstance();

Validator.extend('phone', {
  getMessage: () => 'We couldn\'t recognize that phone number format',
  validate: value => /^[0-9\+\(\)\s\-]*$/.test(value)
});

Validator.extend('nzPhoneNumber', { 
  getMessage: () => 'This phone number is not valid',
  validate: value => /((^((\+64|0)+(3|4|5|6|7|9))+\d{7}$)|(^((\+64|0)+(20|21|22|27|28|29))+\d{6,8}$))/.test(value) 
});

Validator.extend('nzMobileNumber', { 
  getMessage: () => 'This mobile number is not valid',
  validate: value => /(^((\+64|0)+(20|21|22|27|28|29))+\d{6,8}$)/.test(value) 
});

Validator.extend('digitsonly', {
  getMessage: () => 'Clubcard number needs to be digits only',
  validate: value => /^[0-9]*$/.test(value.replace(/ /g, ''))
});

Validator.extend('cardstart', {
  getMessage: () => 'Clubcard number should start with 6014 3555',
  validate: value => value.replace(/ /g, '').startsWith('60143555')
});

Validator.extend('letterMin', {
  getMessage: () => 'The password must have at least one letter',
  validate: value => /[a-zA-Z]/.test(value) 
});

Validator.extend('numberMin', {
  getMessage: () => 'The password must have at least one number',
  validate: value => /[0-9]/.test(value)
});

Validator.extend('hybrisSpecialCharacters', {
  getMessage(field, params, data) {
    let uniqueCharacters: string[] = _.uniq(data);
    let plural = ' symbol is';

    if (uniqueCharacters.length > 1) {
      plural = ' symbols are';
    }
    return 'The ' + uniqueCharacters.join(', ') + plural + ' not allowed';
  },
  validate: value => ({
    valid: /^[\w!@$%^&*()_+=\-{};:'",.<>?|~`]+$/.test(value),
    data: Array.from(value.replace(/[\w!@$%^&*()_+=\-{};:'",.<>?|~`]/g, ''))
  })
});

Validator.extend('firstNameLimitedCharacters', {
  getMessage: () => 'Sorry, your first name may only contain letters, spaces, hyphens and apostrophes. Please check and try again',
  validate: value => /^[a-zA-Z0-9\s-'’]*$/.test(value)
});

Validator.extend('lastNameLimitedCharacters', {
  getMessage: () => 'Sorry, your last name may only contain letters, spaces, hyphens and apostrophes. Please check and try again',
  validate: value => /^[a-zA-Z0-9\s-'’]*$/.test(value)
});

Validator.extend('fsEmailExtention', {
  getMessage: () => 'That email doesn\'t look right',
  validate: value => !/^(\.|\"|.*\.{2,}|.*\.@)/.test(value)
});




// WEBPACK FOOTER //
// ./src/custom-validators.ts